export default __webpack_public_path__ + "static/media/reviewImage1.22be8343.png";